import React from 'react';
import Form from '../forms/FullScreenForm';
import { CKP_COLOR_GREEN } from '../../../constants/styling/styles';
import { Link } from 'react-router-dom';
import { ROOT_PATH } from '../../../constants/routes';

const PasswordChangeSuccess = () => (
    <Form
        header={'Yippee ki-yay!'}
        body={
            <div className="ckp-forms-info">
                <i className="fa fa-check-circle ckp-forms-info-icon fa-4x" style={{ color: CKP_COLOR_GREEN }} />
                <p className="ckp-forms-info-text">
                    <span>Your new password is saved.</span>
                </p>
                <Link className="ckp-buttons-link" to={ROOT_PATH}>
                    Okay
                </Link>
            </div>
        }
        footer={null}
    />
);

export default PasswordChangeSuccess;
